import { Categories } from "Data/Objects/Category";

export const isCategory = (value: unknown): value is Categories => {
	return typeof value === "string" && Object.keys(Categories).includes(value);
};
